export const SET_APP_TITLE = 'SET_APP_TITLE'